export default "__VITE_ASSET__CmKBzJux__"